import type { ChoirFunction, DocumentType, Member, MemberType, Voice } from '../types'

type Raw = [
  ime: string,
  priimek: string,
  type: MemberType,
  voice: Voice,
  functions: ChoirFunction[],
  naslov: string,
  postnaStevilka: string,
  posta: string,
  telefon: string,
  email: string,
  datumRojstva: string,
  clanOd: string,
  prisoten: number,
  pricakovan: number,
]

/** Seznam članov MEPZ VIVA Brežice, september 2026. */
const raw: Raw[] = [
  ['Aljaž', 'Arh', 'aktivni', 'tenor', ['pevec', 'uo_clan', 'prevajalec'], 'Žadovinek 30', '8273', 'Leskovec pri Krškem', '051 717 792', 'aljaz.arh@gmail.com', '2001-04-07', '2018-03-09', 20, 24],
  ['Nina', 'Bobnič', 'aktivni', 'sopran', ['pevec'], 'Kladje nad Blanco 7 a', '8283', 'Blanca', '041 518 974', 'bobnicnina@gmail.com', '2003-02-15', '2020-01-17', 19, 24],
  ['Lucija', 'Bosina', 'aktivni', 'alt', ['pevec', 'uo_clan'], 'Ulica Jožeta Šavriča 34', '8257', 'Dobova', '040 734 149', 'lucija.bosina@gmail.com', '1994-12-05', '2020-06-26', 22, 24],
  ['Uroš', 'Brezovšek', 'aktivni', 'bariton', ['pevec'], 'Titova cesta 14', '8281', 'Senovo', '041 420 175', 'uros.brezovsek@gmail.com', '1977-02-26', '1992-10-07', 21, 24],
  ['Lidija', 'Cizel', 'aktivni', 'sopran', ['pevec'], 'Pesje 5 a', '8270', 'Krško', '041 675 551', 'lidija.cizel@siol.net', '1978-02-23', '1996-06-01', 18, 24],
  ['Ivanka', 'Črnelič Jurečič', 'aktivni', 'alt', ['pevec', 'uo_blagajnik'], 'Podbočje 47', '8312', 'Podbočje', '031 767 679', 'maat@siol.net', '1970-09-17', '2018-03-02', 23, 24],
  ['Alenka', 'Črnelič Krošelj', 'aktivni', 'alt', ['pevec', 'dk_predsednik'], 'Stiplovškova ulica 18 a', '8250', 'Brežice', '031 342 252', 'alenkack@gmail.com', '1972-07-28', '1994-09-01', 17, 24],
  ['Veronika', 'Fabeković', 'aktivni', 'alt', ['pevec', 'porocevalec'], 'Kalce - Naklo 14', '8312', 'Podbočje', '040 513 552', 'veronika.fabekovic@gmail.com', '1989-11-29', '2023-01-20', 20, 24],
  ['Maruša', 'Ferenčak', 'aktivni', 'alt', ['pevec', 'kronika'], 'Silovec 9', '8256', 'Sromlje', '041 896 283', 'marusa.ferencak1@gmail.com', '2002-10-18', '2018-05-25', 15, 23],
  ['Benjamin', 'Ferk', 'aktivni', 'tenor', ['pevec'], 'Kregarjeva ulica 38', '8250', 'Brežice', '051 204 074', 'benjamin.ferk.7@gmail.com', '2007-12-12', '2023-01-20', 22, 24],
  ['Barbara', 'Ganzitti Siter', 'aktivni', 'alt', ['pevec'], 'Grebenčeva cesta 4', '8273', 'Leskovec pri Krškem', '040 614 914', 'barbaragsiter@gmail.com', '1979-12-17', '2026-01-30', 6, 7],
  ['Klemen', 'Glas', 'aktivni', 'bariton', ['pevec'], 'Trg izgnancev 10 e', '8250', 'Brežice', '040 324 631', 'klemen.glas@gmail.com', '1987-09-27', '2026-03-27', 4, 5],
  ['Samo', 'Hajtnik', 'aktivni', 'bas', ['pevec', 'digitalizacija'], 'Brezje pri Bojsnem 3 a', '8254', 'Globoko', '031 346 345', 'samohajtnik@gmail.com', '1961-09-16', '2018-03-02', 21, 24],
  ['Irena', 'Hribar', 'aktivni', 'alt', ['pevec'], 'Stritarjeva ulica 3', '8250', 'Brežice', '041 413 303', 'asterix@t-2.si', '1969-01-24', '1996-10-04', 22, 24],
  ['Tinka', 'Hriberšek', 'aktivni', 'sopran', ['pevec'], '', '', '', '', '', '', '2026-01-01', 4, 5],
  ['Mateja', 'Jankovič Čurič', 'aktivni', 'alt', ['pevec'], 'Černelčeva cesta 4 a', '8250', 'Brežice', '031 701 787', 'matejacuric@gmail.com', '1974-08-09', '1994-09-01', 19, 24],
  ['Dejan', 'Jerončič', 'aktivni', 'bas', ['pevec', 'korepetitor', 'no_clan'], 'Artiče 59 b', '8253', 'Artiče', '040 329 136', 'dejan.jeroncic@gmail.com', '1975-11-10', '2023-12-08', 21, 24],
  ['Bojan', 'Kaplan', 'aktivni', 'bariton', ['pevec'], 'Železniška pot 10', '8257', 'Dobova', '031 589 818', 'bojankaplan4@gmail.com', '1957-04-21', '1995-09-01', 18, 24],
  ['Lara', 'Krivec', 'aktivni', 'sopran', ['pevec'], 'Žejno 34', '8262', 'Krška vas', '031 654 405', 'lara.ostrbenk@gmail.com', '1998-09-14', '2015-03-06', 20, 24],
  ['Karmen', 'Kukovičič', 'aktivni', 'sopran', ['pevec'], 'Dolenje Skopice 33', '8262', 'Krška vas', '031 768 657', 'karmenkukovicic@gmail.com', '1995-05-03', '2026-08-24', 1, 2],
  ['Barbara', 'Les', 'aktivni', 'sopran', ['pevec', 'no_clan'], 'Rimska cesta 31', '8250', 'Brežice', '040 559 530', 'barbara@pension.si', '1979-05-07', '1996-06-01', 19, 24],
  ['Anja', 'Lipej', 'aktivni', 'sopran', ['pevec'], 'Pot na Žalce 11', '8259', 'Bizeljsko', '030 768 400', 'anja.lipej@gmail.com', '2005-07-03', '2025-07-04', 16, 23],
  ['Maj', 'Medvešek', 'aktivni', 'bariton', ['pevec'], 'Bizeljska cesta 11', '8250', 'Brežice', '070 309 816', 'maimedvesek1@gmail.com', '2009-08-20', '2025-08-27', 17, 23],
  ['Maj', 'Mihelčič', 'aktivni', 'bariton', ['pevec'], 'Ledina 36', '4270', 'Bled', '051 620 335', 'majmihelcic4@gmail.com', '2001-06-10', '2025-08-27', 13, 22],
  ['Eva', 'Oštrbenk', 'aktivni', 'alt', ['pevec', 'arhiv', 'kronika', 'omrezja'], 'Žejno 34', '8262', 'Krška vas', '031 294 268', 'eva.ostrbenk@gmail.com', '2005-12-19', '2021-11-05', 21, 24],
  ['Dean Jan', 'Petan', 'aktivni', 'bariton', ['pevec'], 'Hrastinska pot 9', '8250', 'Brežice', '041 753 702', 'dean.petan@gmail.com', '1996-07-14', '2019-12-13', 18, 24],
  ['Katarina', 'Petrič', 'aktivni', 'alt', ['pevec'], 'Dvorce 11 a', '8250', 'Brežice', '041 902 561', 'katka.53c@gmail.com', '2006-12-11', '2022-09-30', 20, 24],
  ['Jasna', 'Polovič', 'aktivni', 'sopran', ['pevec'], 'Cesta bratov Milavcev 55', '8250', 'Brežice', '040 953 508', 'jasna.druskovic@gmail.com', '1991-05-16', '2026-01-16', 6, 7],
  ['Katja', 'Plevnik', 'aktivni', 'alt', ['pevec'], 'Pišece 46 g', '8255', 'Pišece', '031 595 453', 'katja.plevnik1@gmail.com', '2007-07-16', '2024-08-22', 19, 24],
  ['Katja', 'Povše', 'aktivni', 'sopran', ['pevec', 'dk_clan'], 'Nimnik 26', '8259', 'Bizeljsko', '041 954 684', 'katja.mihelin@gmail.com', '1986-10-05', '2016-09-08', 21, 24],
  ['Jure', 'Pregelj', 'aktivni', 'bas', ['pevec'], 'Ulica Stanka Škalerja 29', '8250', 'Brežice', '051 247 149', 'jure.pregelj@cgp.si', '1975-05-19', '2008-03-21', 17, 24],
  ['Mateja', 'Račič', 'aktivni', 'sopran', ['pevec'], 'Seidlova cesta 64', '8000', 'Novo mesto', '031 691 530', 'mateja_racic@yahoo.com', '1982-02-17', '2013-01-04', 14, 22],
  ['Janž', 'Rener', 'aktivni', 'tenor', ['pevec'], 'Pišece 24 a', '8255', 'Pišece', '031 287 765', 'janz.rener@gmail.com', '2006-04-09', '2023-03-10', 15, 22],
  ['Robert', 'Rožman', 'aktivni', 'tenor', ['pevec'], 'Linhartova ulica 1', '8250', 'Brežice', '031 609 790', 'janynka.r@gmail.com', '1974-11-25', '2020-09-18', 20, 24],
  ['Hana', 'Sambunjak', 'aktivni', 'sopran', ['pevec', 'prevajalec'], 'Ulica Elizabete Zorko 2', '8250', 'Brežice', '069 662 342', 'ha.sambunjak@gmail.com', '2003-05-31', '2019-05-31', 18, 24],
  ['Vita', 'Sambunjak', 'aktivni', 'sopran', ['pevec', 'uo_opazovalec', 'omrezja'], 'Ulica Elizabete Zorko 2', '8250', 'Brežice', '069 662 343', 'mobilni.vita@gmail.com', '2005-07-23', '2023-01-20', 20, 24],
  ['Timotej', 'Siter', 'aktivni', 'bas', ['pevec'], 'Grebenčeva cesta 4', '8273', 'Leskovec pri Krškem', '040 557 673', 'timotejsiter@gmail.com', '1983-02-10', '2026-01-30', 5, 7],
  ['Lora Ana', 'Starič', 'aktivni', 'alt', ['pevec'], 'Podbočje 47', '8312', 'Podbočje', '051 631 970', 'lora.jurecic@gmail.com', '2000-06-08', '2020-09-24', 22, 24],
  ['Kaja', 'Strnad', 'aktivni', 'sopran', ['pevec', 'arhiv'], 'Šolska ulica 6', '8250', 'Brežice', '031 442 225', 'kaja.rozman6@gmail.com', '1989-04-13', '2005-12-02', 21, 24],
  ['Krištof', 'Strnad', 'aktivni', 'brez', ['dirigent', 'uo_strokovni'], 'Šolska ulica 6', '8250', 'Brežice', '070 694 381', 'kristof.strnad@gmail.com', '1999-07-02', '2015-01-09', 24, 24],
  ['Neli', 'Škofca', 'aktivni', 'alt', ['pevec'], 'Globoko 67', '8254', 'Globoko', '069 644 662', 'neli.skofca@gmail.com', '2008-05-03', '2025-07-04', 12, 22],
  ['Mirjam', 'Šolar', 'aktivni', 'alt', ['pevec'], 'Trg izgnancev 10 e', '8250', 'Brežice', '040 836 206', 'solar.mirjam@gmail.com', '1995-04-13', '2026-03-06', 4, 5],
  ['Ana', 'Špiler', 'aktivni', 'alt', ['pevec', 'dk_clan'], 'Pleterje 6', '8272', 'Zdole', '031 329 626', 'spiler.ana@gmail.com', '1982-11-11', '2016-04-01', 21, 24],
  ['Amir', 'Tokić', 'aktivni', 'bariton', ['pevec', 'uo_clan', 'splet'], 'Maistrova ulica 4', '8250', 'Brežice', '041 598 225', 'amir.tokic@gmail.com', '1982-03-16', '1997-09-01', 19, 24],
  ['Florijan', 'Volčanšek', 'aktivni', 'tenor', ['pevec'], 'Cundrovec 16 b', '8250', 'Brežice', '070 471 156', 'florijanvolcansek123@gmail.com', '2000-08-04', '2017-06-23', 23, 24],
  ['Judita', 'Volčanšek', 'aktivni', 'sopran', ['pevec', 'evidenca', 'gospodar'], 'Cundrovec 16 b', '8250', 'Brežice', '070 482 153', 'jvolcansek@gmail.com', '1999-02-12', '2016-09-23', 22, 24],
  ['Petra', 'Žibert', 'aktivni', 'sopran', ['pevec'], 'Brezovo 7 a', '8293', 'Studenec', '041 774 758', 'pety.zibert@gmail.com', '1983-10-29', '2016-10-28', 18, 24],
  ['Sabina', 'Žibert', 'aktivni', 'alt', ['pevec', 'no_predsednik', 'uniforme'], 'Gorenje Skopice 10', '8262', 'Krška vas', '031 516 623', 'sabinas.mail@gmail.com', '1985-08-20', '2000-10-13', 20, 24],
  ['Doroteja', 'Žinko', 'aktivni', 'sopran', ['pevec'], 'Artiče 24 a', '8253', 'Artiče', '051 885 991', 'zinko.doroteja@gmail.com', '1997-09-23', '2016-01-08', 16, 24],
  ['Ana', 'Žnideršič', 'aktivni', 'sopran', ['pevec', 'uo_tajnik'], 'Črnc 65', '8250', 'Brežice', '041 319 403', 'ana.znidersic@gmail.com', '2002-08-02', '2019-01-18', 22, 24],
  ['Jelka', 'Žnideršič', 'aktivni', 'alt', ['pevec', 'uo_predsednik'], 'Sodarska pot 15', '8250', 'Brežice', '031 456 204', 'jelka.znidersic@gmail.com', '1991-01-23', '2011-09-01', 23, 24],
  ['Jurij', 'Žnideršič', 'aktivni', 'tenor', ['pevec'], 'Sodarska pot 15', '8250', 'Brežice', '041 948 117', 'jurij.znidersic@gmail.com', '1988-08-25', '2006-09-01', 20, 24],

  // ——— častni člani ———
  ['Lučka', 'Črnelič', 'castni', 'alt', ['pevec', 'dk_nadomestni', 'kronika'], 'Šolska ulica 1', '8250', 'Brežice', '031 329 636', 'luckald@yahoo.com', '1961-01-29', '1992-10-01', 6, 11],
  ['Anton', 'Hribar', 'castni', 'bas', ['pevec', 'dk_nadomestni'], 'Stritarjeva ulica 3', '8250', 'Brežice', '041 365 642', 'tonihribar64@gmail.com', '1964-02-28', '1992-10-01', 5, 11],
  ['Simona', 'Rožman Strnad', 'castni', 'alt', ['pevec', 'arhiv'], 'Arnovo selo 39 a', '8253', 'Artiče', '041 334 937', 'simonastrnad@rudolfgas.com', '1968-10-25', '1992-10-01', 8, 12],
]

/** Namerno nepopolni podatki — za prikaz kontrole pred gostovanjem. */
const vrzeli: Record<string, ('dokumentTip' | 'dokumentStevilka' | 'datumRojstva')[]> = {
  'Timotej Siter': ['dokumentStevilka'],
  'Katja Plevnik': ['dokumentTip', 'dokumentStevilka'],
  'Janž Rener': ['dokumentStevilka'],
  'Tinka Hriberšek': ['datumRojstva', 'dokumentTip', 'dokumentStevilka'],
}

/** Posebnosti pri prehrani. */
const prehranaPosebnosti: Record<string, string> = {
  'Irena Hribar': 'Brez glutena in mleka; od mesa le piščanec in riba',
  'Simona Rožman Strnad': 'Brez glutena',
  'Kaja Strnad': 'Brez glutena, mlečnih izdelkov, svinjine in govedine',
  'Amir Tokić': 'Brez svinjine',
  'Ana Špiler': 'Vegetarijanska prehrana',
}

export const members: Member[] = raw.map(
  (
    [
      ime,
      priimek,
      type,
      voice,
      functions,
      naslov,
      postnaStevilka,
      posta,
      telefon,
      email,
      datumRojstva,
      clanOd,
      prisoten,
      pricakovan,
    ],
    i,
  ) => {
    const id = `m${String(i + 1).padStart(2, '0')}`
    const kljuc = `${ime} ${priimek}`
    const dokTip: DocumentType = i % 6 === 0 ? 'potni_list' : 'osebna'
    const manjka = vrzeli[kljuc] ?? []

    const clan: Member = {
      id,
      ime,
      priimek,
      type,
      voice,
      functions,
      email,
      telefon,
      clanOd,
      naslov: naslov || undefined,
      postnaStevilka: postnaStevilka || undefined,
      posta: posta || undefined,
      datumRojstva: datumRojstva || undefined,
      dokumentTip: dokTip,
      dokumentStevilka: `${dokTip === 'potni_list' ? 'PB' : 'OI'}${String(1000000 + i * 7919).slice(0, 7)}`,
      prehrana: prehranaPosebnosti[kljuc],
      prisoten,
      pricakovan,
      opomba:
        type === 'castni'
          ? 'Častni član zbora. Vabljen na vse slovesne dogodke, prisotnost se ne spremlja strogo.'
          : undefined,
    }

    manjka.forEach((polje) => {
      delete clan[polje]
    })

    return clan
  },
)

export const byId = (id: string): Member | undefined => members.find((m) => m.id === id)

/** Poišče člana po imenu in priimku — uporabno pri vnosu mock podatkov. */
export function idOf(ime: string, priimek: string): string {
  return members.find((m) => m.ime === ime && m.priimek === priimek)?.id ?? ''
}

/** Predstavitveni profili na prijavnem zaslonu. */
export const DEMO_CLAN = idOf('Judita', 'Volčanšek')
export const DEMO_GOST = idOf('Lučka', 'Črnelič')
export const DEMO_ADMIN = idOf('Krištof', 'Strnad')
